import { Button, Grid } from "@mui/material";
import { useNavigate  } from "react-router-dom";
import PropTypes from 'prop-types';
import { ChevronLeft } from "@mui/icons-material";

const FooterButtons = ({backLabel, nextLabel, backDisabled, nextDisabled, onBack, onNext, hideBack, hideNext}) => {
	const navigate = useNavigate();

	const onBackClick = () => {
		onBack ? onBack() : navigate(-1);
	}

	const onNextClick = () => {
		onNext ? onNext() : navigate(1);
	}

	return (
		<Grid container width="100%" paddingY="4px">
			<Grid item xs={6}>
				{!hideBack && 
				<Button
				variant="outline"
				onClick={onBackClick}
				startIcon={<ChevronLeft/>}
				disabled={backDisabled}>{backLabel}</Button>
				}
			</Grid>
			<Grid item xs={6} display="flex" justifyContent="flex-end">
				{!hideNext && <Button variant="contained" onClick={onNextClick} disabled={nextDisabled}>{nextLabel}</Button>}
			</Grid>
		</Grid>
	)
}

FooterButtons.propTypes = {
	backLabel: PropTypes.string,
	nextLabel: PropTypes.string,
	backDisabled: PropTypes.bool,
	nextDisabled: PropTypes.bool,
	onBack: PropTypes.func,
	onNext: PropTypes.func,
	hideBack: PropTypes.bool,
	hideNext: PropTypes.bool,
}

FooterButtons.defaultProps = {
	backLabel: 'Go Back',
	nextLabel: 'Continue'
}

export default FooterButtons;